import { memo } from 'react';
import { Box } from '@mui/material';

import { truncateString, cleanStringFromHtmlAndBloxInline } from 'utility/functions';

import { getAssetPreviewImage } from '../../const';

const InlineArticleDisplay = memo((asset: any) => {
  const { title, summary } = asset;
  const preview = getAssetPreviewImage(asset);

  const cleanedSummary = summary && cleanStringFromHtmlAndBloxInline(summary);
  const displaySummary = cleanedSummary && truncateString(cleanedSummary, 150);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: preview && 'auto 1fr',
        gap: 2,
        alignItems: 'center',
        '--border-color': '#000',
        '--background-color': '#fff',
      }}
    >
      {preview && (
        <Box sx={{ width: 200 }}>
          <img
            src={preview}
            alt={title}
            style={{ width: '100%', borderRadius: 4 }}
          />
        </Box>
      )}
      <Box>
        <Box
          sx={(theme) => ({
            marginTop: 2,
            '--border-color': theme.palette.mode === 'dark' ? '#fff' : '#000',
            '--background-color': theme.palette.mode === 'dark' ? '#000' : '#fff',
          })}
        >
          {displaySummary}
        </Box>
      </Box>
    </Box>
  );
});

export default InlineArticleDisplay;
